import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IPromotionsConfigurationState = {
    promotionsFeeds: {}
};

export const reducer = produce((
    draftState,
    action: Types.TPromotionsConfigurationAction
): Types.IPromotionsConfigurationState | void => {
    switch (action.type) {
        case actionTypes.PROMOTIONS_CONFIGURATION_PROMOTIONS_FEED_ADD: {
            const { name } = action.payload;

            draftState.promotionsFeeds[name] = action.payload;

            break;
        }
        case actionTypes.PROMOTIONS_CONFIGURATION_UPDATE: {
            draftState.promotions = action.payload.promotions;
            draftState.promotionInfoLayout = action.payload.promotionInfoLayout;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
